let token = 'token'
export const getToken = () => {
  return localStorage.getItem(token)
}

export const setToken = value => {
  localStorage.setItem(token, value)
}



// WEBPACK FOOTER //
// ./src/token.js